import React from 'react';

import { Box } from '@mui/material';

import { styledComponent } from 'src/utils/styled';
import Image from 'src/components/ui/Image';
import Typography from 'src/components/ui/Typography';
import Button from 'src/components/ui/Button';
import { colours } from 'src/constants/colours';

const PartnershipContainer = styledComponent(Box)<{ $width?: string }>`
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    border-radius: 1rem;
    padding: 0.8rem;
    background-color: ${colours.white.main};
    width: ${({ $width }) => $width ?? 'auto'};
`;

type Props = {
    imageUrl: string;
    title: string;
    description: string;
    buttonText: string;
    buttonHref?: string;
    buttonOnClick?: () => void;
    width?: string;
};

export const PartnershipBlock: React.FC<Props> = ({
    imageUrl,
    title,
    description,
    buttonText,
    buttonHref,
    buttonOnClick,
    width,
}) => (
    <PartnershipContainer $width={width}>
        <Box display="flex" alignItems="center">
            <Image
                src={imageUrl}
                alt="ilek partner image"
                height={38}
                width={38}
                style={{ background: 'transparent', marginLeft: '0.3rem' }}
            />
            <Typography weight="bold" marginLeft="0.5rem">
                {title}
            </Typography>
        </Box>
        <Typography>{description}</Typography>
        <Button onClick={buttonOnClick} href={buttonHref} target="_blank" rel="noopener noreferrer">
            {buttonText}
        </Button>
    </PartnershipContainer>
);
